declare const history: any;
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { Player } from 'src/models/player.model';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { MyScores } from 'src/models/myscores.model';
import { UserService } from 'src/services/user.service';
import { map } from 'rxjs/operators';
import { ProfileService } from '../profile/profile.service';

@Component({
  selector: 'clear-cookies',
  templateUrl: './clearcookies.component.html',
  styleUrls: ['clearcookies.component.scss']
})
export class ClearCookiesComponent implements OnInit {

  constructor(private route: Router, private userSvc: UserService) {
  }

  ngOnInit(): void {
    this.userSvc.clearCache();
    localStorage.removeItem('ladderId');
    localStorage.removeItem('levelId');
    localStorage.removeItem('impersonate');
    this.route.navigate(['/home']);
  }
}
